module.exports = __webpack_public_path__ + "img/clou02.6dfd2759.png";